import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import LockCpt from '@/components/lock';
import { mapGetters } from 'vuex';
import { rqtPostUserPrivilegeVerify, rqtPostUserPrivilegeSave } from '@/services/common';
export default {
  components: {
    PageNavBackLayoutCpt,
    LockCpt
  },
  data() {
    return {
      result: false
    };
  },
  computed: {
    ...mapGetters('account', ['user'])
  },
  mounted() {
    /* if (this.user.isSetPwd === 'Y') {
      this.$refs['LockCpt'].hideUpdatePassword()
    } else {
      this.$refs['LockCpt'].updatePassword()
    } */

    if (this.user.isSetPwd === 'Y') {
      this.$refs['LockCpt'].hideUpdatePassword();
    } else {
      this.$refs['LockCpt'].updatePassword();
    }
  },
  methods: {
    onHideEvent() {
      this.$router.replace('/wx/main');
    },
    onCheckPwd(pwd) {
      return rqtPostUserPrivilegeVerify({
        userId: this.user.userId,
        password: pwd
      });
    },
    onSavePwd(pwd) {
      return rqtPostUserPrivilegeSave({
        userId: this.user.userId,
        password: pwd
      });
    }
  }
};